"use client";

import { useSessionChatModeActions } from "./use-session-chat-mode-actions";
import { useSessionMainChatActions } from "./use-session-main-chat-actions";
import { useSessionProductCollabActions } from "./use-session-product-collab-actions";
import type {
  SessionChatActionDependencies,
  SessionChatActions,
} from "./use-session-chat-actions.types";

export type {
  SessionChatActionDependencies as UseSessionChatActionsInput,
  SessionChatActions,
} from "./use-session-chat-actions.types";

export function useSessionChatActions(
  input: SessionChatActionDependencies,
): SessionChatActions {
  const chatModeActions = useSessionChatModeActions(input);
  const mainChatActions = useSessionMainChatActions(input);
  const productCollabActions = useSessionProductCollabActions(input);

  return {
    ...chatModeActions,
    ...mainChatActions,
    ...productCollabActions,
  };
}
